<template>
  <van-popup v-model="show" position="bottom">
    <div class="protocol-main">
      <platform-rules class="platformRules" />
      <div v-if="bottomTipShow" class="bottomTipShow">点击按钮即为同意平台须知</div>
      <div class="btn-main">
        <button :class="{'isDisable': isDisable}" class="agreen-btn" @click="confrimBtn">{{ comfirmText }}</button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import PlatformRules from "@/components/puppetComponent/PlatformRules";
import { Popup } from "vant";
export default {
  name: "PlatformProtocol",
  components: { PlatformRules, "van-popup": Popup },
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    comfirmText: {
      type: String,
      require: true,
      default: '同意'
    },
    isDisable: {
      type: Boolean,
      require: true,
      default: false
    },
    bottomTipShow: {
      type: Boolean,
      require: true,
      default: true
    }
  },
  watch: {
    visible(val) {
      this.show = val;
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    confrimBtn() {
      this.$emit('confirm')
    },
  },
};
</script>

<style lang="scss" scoped>
.protocol-main {
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  overflow-y: scroll;
  padding-top: 15px;
}
.platformRules {
  flex: 1;
  overflow: scroll;
}
.btn-main {
  width: 92%;
  height: 52px;
  margin: 0 auto;
  border-top: 1px solid #dddddd;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  box-sizing: border-box;
}
.agreen-btn {
  width: auto;
  height: 36px;
  line-height: 36px;
  background: #3e9fff;
  color: #fff;
  font-size: 16px;
  border-radius: 18px;
  padding: 0 16px;
  &.isDisable {
    background-color: #ccc;
    border: none;
    opacity: .8;
  }
}
.bottomTipShow {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 40px;
  font-size: 13px;
  color: #aca9a9;
}
</style>
